export enum EService{
    FAQ_SET_STAGE = 'FAQ_SET_STAGE',
    FAQ_SET_CATEGORY = 'FAQ_SET_CATEGORY',
    FAQ_SET_POPULAR_ARTICLES = 'FAQ_SET_POPULAR_ARTICLES',
    FAQ_SET_ACTIVE_CATEGORY = 'FAQ_SET_ACTIVE_CATEGORY',
    FAQ_SET_ACTIVE_ARTICLE = 'FAQ_SET_ACTIVE_ARTICLE',
    FAQ_SET_PAGE_LOADING = 'FAQ_SET_PAGE_LOADING',
    FAQ_SET_DATA_LOADING = 'FAQ_SET_DATA_LOADING',
    FAQ_CLEAR_ACTIVE = 'FAQ_CLEAR_ACTIVE',
}
